import './meetings.less';
import * as _ from 'lodash';
import * as utility from '../../misc/utility';

function updateCriteriaDate(criteria) {
    var today = utility.todayDate();

    if (criteria.PersonId != null || (criteria.OrganizationIds != null && criteria.OrganizationIds.length > 0)) {
        criteria.DateFrom = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());
        criteria.DateTo = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
    } else {
        criteria.DateFrom = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
        criteria.DateTo = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
    }
}

function createCriteria(paramCriteria) {

    let criteria = {
        OrganizationIds: [],
        PersonId: null,
        MeetingType: null,
    };

    if (paramCriteria) {
        _.extend(criteria, _.cloneDeep(paramCriteria));
    } else {
        updateCriteriaDate(criteria);
    }

    return criteria;
}

angular.module("tromanWeb").controller('RegularMeetingsController', ['$q', 'stateService', 'tromanServer', 'dialogService', 'ObjectCache', 'meetingsShared', function ($q, stateService, tromanServer, dialogService, ObjectCache, meetingsShared) {

    this.items = null;
    this.displayedItems = [];

    function searchWithCriteria(criteria) {
        let sc = _.cloneDeep(criteria);
        return tromanServer.Meetings.search(sc);
    }

    this._loadItems = function _loadItems(resultPromise) {
        this.items = null;
        this.busy = true;
        resultPromise.then(data => {
            this.error = null;
            this.items = data;
        }).catch(err => {
            this.error = err;
            this.items = null;
        }).finally(() => {
            this.busy = false;
        });
    };

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'criteria')) {
            this.criteria = createCriteria(changed.criteria);
            this._loadItems(searchWithCriteria(this.criteria));
        }

        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this.$onInit = function () {
        const params = stateService.getParams();
        this.criteria = createCriteria(params.criteria);
        this.filter = params.filter;

        meetingsShared.getAddIdCallback = () => this.getAddId();

        this._loadItems($q.all({
            organizations: ObjectCache.getOrganizations(),
            persons: ObjectCache.getPersons(),
            meetings: searchWithCriteria(this.criteria),
        }).then(data => {
            this.organizations = data.organizations;
            this.persons = data.persons;
            return data.meetings;
        }));
    };

    this.hasValidCriteria = function () {
        if (this.criteria.PersonId != null) {
            return true;
        }

        if (this.criteria.OrganizationIds != null && this.criteria.OrganizationIds.length > 0) {
            return true;
        }

        if (this.criteria.DateFrom != null && this.criteria.DateTo != null) {
            var diff = this.criteria.DateTo - this.criteria.DateFrom;

            if (diff < (93 * 24 * 60 * 60 * 1000)) {
                return true;
            }
        }

        return false;
    };

    this.setDefaultDate = function setDefaultDate() {
        updateCriteriaDate(this.criteria);
    };

    this.canSearch = function canSearch() {
        if (this.busy) {
            return false;
        }

        return this.hasValidCriteria();
    };

    this.search = function search() {
        if (!this.canSearch()) return;
        stateService.reloadWithParams({ criteria: _.cloneDeep(this.criteria) });
    };

    this.filterChanged = function () {
        stateService.replaceParams({ filter: this.filter });
    };

    this.createList = function createList() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createMeetingList(list);
    };

    this.getAddId = function getAddId() {
        if (this.criteria.OrganizationIds && this.criteria.OrganizationIds.length > 0) {
            return this.criteria.OrganizationIds[0];
        } else {
            return null;
        }
    };
}]);
